// src/components/account/MyAccountPage.js
// MODIFICADO: Se implementa el logout automático 3 segundos después de mostrar el modal de éxito.

import React, { useState } from 'react';
import { Card, Descriptions, Divider, Form, Input, Button, message, Alert, Typography, Row, Col, Modal } from 'antd';
import { useAuth } from '../../context/AuthContext';
import { adminService } from '../../services/api'; 


const { Title } = Typography;

const MyAccountPage = () => {
    const { user, logout } = useAuth();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [modal, contextHolder] = Modal.useModal();

    const onFinish = async (values) => {
        setLoading(true);
        setError(null);
        try {
            const { currentPassword, newPassword } = values;
            await adminService.changePassword({ currentPassword, newPassword }); 

            setLoading(false);
            modal.success({
                title: '¡Contraseña Actualizada!',
                content: 'Tu contraseña se ha cambiado exitosamente. Serás redirigido para iniciar sesión de nuevo.',
                // Ocultamos el botón "OK" para que el usuario sepa que la acción es automática.
                okButtonProps: { style: { display: 'none' } }
            });

            // Iniciamos un temporizador de 3 segundos
            setTimeout(() => {
                // Destruimos todos los modales abiertos para una transición limpia
                Modal.destroyAll();
                // Ejecutamos el cierre de sesión
                logout();
            }, 3000); // 3000 milisegundos = 3 segundos
            // --- FIN DE CORRECCIÓN ---

        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Ocurrió un error inesperado.';
            setError(errorMessage);
            setLoading(false);
        } 
    };

    return (
        <Row justify="center">
            <Col xs={24} sm={20} md={16} lg={12}>
                {contextHolder}
                <Card>
                    <Title level={3}>Mi Cuenta</Title>
                    {user && (
                        <Descriptions bordered column={1}>
                            <Descriptions.Item label="Nombre de Usuario">{user.username}</Descriptions.Item>
                            <Descriptions.Item label="Nombre Completo">{user.fullName}</Descriptions.Item>
                            <Descriptions.Item label="Rol">{user.role?.name || 'No asignado'}</Descriptions.Item>
                        </Descriptions>
                    )}

                    <Divider>Cambiar Contraseña</Divider>

                    {error && (
                        <Alert 
                            message="Error al cambiar la contraseña"
                            description={error}
                            type="error"
                            showIcon
                            closable
                            onClose={() => setError(null)}
                            style={{ marginBottom: 24 }}
                        />
                    )}

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="currentPassword"
                            label="Contraseña Actual"
                            rules={[{ required: true, message: 'Por favor, ingrese su contraseña actual.' }]}
                        >
                            <Input.Password placeholder="Ingrese su contraseña actual" />
                        </Form.Item>

                        <Form.Item
                            name="newPassword"
                            label="Nueva Contraseña"
                            rules={[
                                { required: true, message: 'Por favor, ingrese su nueva contraseña.' },
                                { min: 6, message: 'La contraseña debe tener al menos 6 caracteres.' },
                                { 
                                    pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_-])[A-Za-z\d@$!%*#?&_-]{6,}$/,
                                    message: 'Debe incluir letras, números y al menos un carácter especial (@$!%*#?&_-).'
                                }
                            ]}
                            hasFeedback
                        >
                            <Input.Password placeholder="Ingrese su nueva contraseña" />
                        </Form.Item>

                        <Form.Item
                            name="confirmNewPassword"
                            label="Confirmar Nueva Contraseña"
                            dependencies={['newPassword']}
                            hasFeedback
                            rules={[
                                { required: true, message: 'Por favor, confirme su nueva contraseña.' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Las dos contraseñas que ingresó no coinciden.'));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password placeholder="Confirme su nueva contraseña" />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Guardar Cambios
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};

export default MyAccountPage;